import { BaseDto } from "../base.dto";

export class GiftCardCorporateCardDto extends BaseDto {
    giftCardId: string;
    batchGUID: string;
    cardNumber: string;
    amount: number;
    customerName: string;
    customerEmail: string;
    processed: boolean;
    giftCardReasonId: number;
    note: string;
}